import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import Register from './components/register';
import Login from './components/login';
import Dashboard from './components/Dashboard';
import DetailPage from './components/addDetails';
import AboutPage from './components/aboutPage';
import DataTable from './components/dataTable';
import PrivateRoute from './routes/protected';
import PublicRoute from './routes/public';
import { Toaster } from 'react-hot-toast';
import Flow from './components/reactFlow';
import '@xyflow/react/dist/style.css';
import DrawerAppBar from './components/navbar';
import Home from './components/home';

const router = createBrowserRouter([
    {
        path: '/register',
        element: (
            //  <PublicRoute>
            <Register />
            // </PublicRoute>
        ),
    },

    {
        path: '/',
        element: (
            <PublicRoute>
                <Login />
            </PublicRoute>
        ),
    },
    {
        path: '/login',
        element: (
            <PublicRoute>
                <Login />
            </PublicRoute>
        ),
    },
    {
        path: '/dashboard',
        element: (
            <PrivateRoute>
                <Dashboard />
            </PrivateRoute>
        ),
        children: [
            {
                path: '',
                element: <Home />,
            },
            {
                path: 'detail',
                element: <DetailPage />,
            },
            {
                path: 'detail/:id',
                element: <DetailPage />,
            },
            {
                path: 'aboutpage',
                element: <AboutPage />,
            },
            {
                path: 'empdata',
                element: <DataTable />,
            },
            {
                path: 'empdata/detail/:id',
                element: <DetailPage />,
            },
        ],
    },
]);

function App() {
    return (
        <>
            <Toaster />
            <RouterProvider router={router} />
        </>
    );
}

export default App;
